module.exports = __webpack_public_path__ + "static/media/Optimized-bottle-close-up-container-1028429.38883eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Optimized-bottle-close-up-container-1028429.png
// module id = 94
// module chunks = 0